export enum CompanyRole {
    GlobalAdmin = 0,
    MemberAdmin = 1,
    MemberControlAdmin = 2,
    Member = 3,
    OneFrontAdmin = 4
}